import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared.module';
import { FooterModule } from '../footer/footer.module';
import { HeaderModule } from '../header/header.module';
import { NavigationModule } from '../navigation/navigation.module';
import { LayoutComponent } from './layout.component';
import { TopNavigationModule } from '../top-navigation/top-navigation.module';
import { DigitalWalletBannerModule } from '../digital-wallet-banner/digital-wallet-banner.module';
import { SwitchPolicyNotifyModule } from '../switch-policy-notify/switch-policy-notify.module';
import { Is4upsBannerModule } from '../is4ups-banner/is4ups-banner.module';
import { ClmsBannerComponent } from '../clms-banner/clms-banner.component';
import { OutageBannerModule } from '../outage-banner/outage-banner.module';
@NgModule({
  imports: [
    FooterModule,
    HeaderModule,
    NavigationModule,
    SharedModule,
    TopNavigationModule,
    DigitalWalletBannerModule,
    SwitchPolicyNotifyModule,
    // VisibilityAgreementFlyoutModule,
    Is4upsBannerModule,
    OutageBannerModule,
  ],
  exports: [
    ClmsBannerComponent
  ],
  declarations: [LayoutComponent],
  providers: [],
})
export class LayoutModule {}
